export default __webpack_public_path__ + "static/media/nuevoIconoVeDiMobile.7ef96765.png";